import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=2db85338&scoped=true"
import script from "./SessionCard.vue?vue&type=script&lang=js"
export * from "./SessionCard.vue?vue&type=script&lang=js"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=2db85338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db85338",
  null
  
)

export default component.exports